export default __webpack_public_path__ + "static/media/tofu.4bb484ae.wav";